import React from "react";
import DefaultCancelIcon from "../../assets/images/Cancel.svg";
import { gtmPush } from '../../analytics/useGtmPageview.tsx';


const CancelButton = ({ onClick, text, type = "button", icon, style={}, ariaLabel }) => {
  const iconToRender = icon || DefaultCancelIcon;

  const handleClick = (e) => {
      // ✅ Push event to GTM
      gtmPush("button_click", {
        elementId: "cancel-button",
        button_text: text,
        page_path: window.location.pathname + window.location.search,
      });
  
      // ✅ Call the parent’s onClick if provided
      if (onClick) {
        onClick(e);
      }
    };

  return (
    <button className="step-btn cancel-btn" onClick={handleClick} type={type} style={{...style}} {...(ariaLabel && { 'aria-label': ariaLabel })}>
      <img src={iconToRender} alt="" />
      {text}
    </button>
  );
};

export default CancelButton;
